import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Video, CalendarDays, ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LivestreamPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/livestream/${token}`).then(({ data }) => setData(data)).catch(() => setError(true));
  }, [token]);

  return (
    <div data-testid="livestream-page" className="flex min-h-screen items-center justify-center bg-[#EAE9F6] px-5">
      <div className="w-full max-w-lg rounded-2xl bg-white p-8 text-center shadow-lg md:p-10">
        <Video className="mx-auto h-10 w-10 text-[#6618D0]" />
        {error && <p data-testid="livestream-invalid" className="mt-4 text-[#4a4a4a]">This invite link isn't valid. Please use the button in your invite email.</p>}
        {!data && !error && <p className="mt-4 text-sm text-[#7a7a7a]">Loading…</p>}
        {data && (
          <>
            <p className="mt-4 text-xs font-extrabold tracking-[0.15em] text-[#990EE5]">PRESALE BONUS</p>
            <h1 data-testid="livestream-title" className="mt-2 font-serif-display text-3xl font-bold text-[#6618D0]">{data.title}</h1>
            {data.customer_name && <p className="mt-2 text-sm text-[#5a5a5a]">Welcome, {data.customer_name}!</p>}
            <div data-testid="livestream-when" className="mx-auto mt-6 inline-flex items-center gap-2 rounded-full bg-[#F3EEFC] px-4 py-2 text-sm font-bold text-[#3A0F7A]">
              <CalendarDays className="h-4 w-4" /> {data.when || "Date coming soon"}
            </div>
            {data.notes && <p className="mt-5 text-sm leading-relaxed text-[#4a4a4a]">{data.notes}</p>}
            {data.join_url ? (
              <a data-testid="livestream-join-button" href={data.join_url} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-md bg-[#6618D0] px-7 py-3.5 font-serif-display text-sm font-bold tracking-wide text-white transition-colors hover:bg-[#5512b0]">
                JOIN THE LIVESTREAM <ArrowUpRight className="h-4 w-4" />
              </a>
            ) : (
              <p className="mt-8 text-sm text-[#7a7a7a]">The join link will appear here before the livestream starts.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
